export default class ModeloGenerico
{
    id:number=0;
    descripcion:string= "";
    estado :boolean = true;
}